import React from "react";
import { Typography } from "antd";
import { CONSTANTS } from "utils/constant";
import { Trans, useTranslation } from "react-i18next";
import { TS_STYLD_COMPS } from "Common/constant";
import "./Loader.scss"; // make sure this CSS file contains your loader styles

const { Text } = Typography;

const Loader = (props) => {
  const { tgtLangST = null } = props;
  const { t } = useTranslation();

  return (
    <div className="loader-container">
      <svg
        className="loader"
        viewBox="0 0 384 384"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="active"
          pathLength="360"
          fill="transparent"
          strokeWidth="32"
          cx="192"
          cy="192"
          r="176"
        ></circle>
        <circle
          className="track"
          pathLength="360"
          fill="transparent"
          strokeWidth="32"
          cx="192"
          cy="192"
          r="176"
        ></circle>
      </svg>

      {/* <Text>
        <Trans components={TS_STYLD_COMPS}>
          {tgtLangST
            ? t(CONSTANTS.PLEASE_WAIT, { lng: tgtLangST })
            : t(CONSTANTS.PLEASE_WAIT)}
        </Trans>
      </Text> */}
    </div>
  );
};

export default Loader;
